import React from 'react';
import {
  Paper,
  Box,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Refresh';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { DateRangePreset } from '../hooks/useDateRange';

interface DashboardHeaderProps {
  preset: DateRangePreset;
  onPresetChange: (preset: DateRangePreset) => void;
  customStartDate: string;
  onCustomStartDateChange: (date: string) => void;
  customEndDate: string;
  onCustomEndDateChange: (date: string) => void;
  onRefresh: () => void;
  refreshing?: boolean;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  preset,
  onPresetChange,
  customStartDate,
  onCustomStartDateChange,
  customEndDate,
  onCustomEndDateChange,
  onRefresh,
  refreshing = false,
}) => {
  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <FilterListIcon color="primary" />
        <ToggleButtonGroup
          value={preset}
          exclusive
          onChange={(_, val) => val && onPresetChange(val)}
          size="small"
        >
          <ToggleButton value="7">7 days</ToggleButton>
          <ToggleButton value="15">15 days</ToggleButton>
          <ToggleButton value="30">30 days</ToggleButton>
          <ToggleButton value="90">90 days</ToggleButton>
          <ToggleButton value="custom">Custom</ToggleButton>
        </ToggleButtonGroup>
        {preset === 'custom' && (
          <>
            <TextField
              type="date"
              size="small"
              label="Start Date"
              value={customStartDate}
              onChange={(e) => onCustomStartDateChange(e.target.value)}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: <CalendarTodayIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />,
              }}
              sx={{ width: 160 }}
            />
            <Typography sx={{ mx: 1 }}>-</Typography>
            <TextField
              type="date"
              size="small"
              label="End Date"
              value={customEndDate}
              onChange={(e) => onCustomEndDateChange(e.target.value)}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: <CalendarTodayIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />,
              }}
              sx={{ width: 160 }}
            />
          </>
        )}
        <Box sx={{ flex: 1 }} />
        <Tooltip title="Refresh Data">
          <IconButton onClick={onRefresh} disabled={refreshing} color="primary">
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Paper>
  );
};

export default DashboardHeader;

